import React from 'react';
import _ from 'lodash';

import {
  PermissionName,
  useLoggedInUserPermissionsQuery
} from 'generated/graphql';



export type IEvaluationCriteria = 'all' | 'some';

export function usePermissions({
  storeId, evaluationCriteria
}: {
  storeId?: string;
  evaluationCriteria?: IEvaluationCriteria;
}) {
  const tuple = useLoggedInUserPermissionsQuery({
    variables: {
      storeId
    }
  });

  const permissions = React.useMemo(
    () => _.map(tuple.data?.loggedInUser?.permissions ?? [], p => p.name),
    [tuple]
  );

  const evaluate = React.useCallback(
    (permission: PermissionName) => _.includes(permissions, permission) || _.includes(permissions, 'platform_godMode'),
    [permissions]
  );

  const hasPermissions = React.useCallback(
    (requestedPermissions: readonly PermissionName[]) => !tuple.loading && (
      evaluationCriteria === 'some'
        ? _.some(requestedPermissions, permission => evaluate(permission))
        : _.every(requestedPermissions, permission => evaluate(permission))
    ),
    [
      tuple.loading,
      evaluationCriteria,
      evaluate
    ]
  );

  return [
    hasPermissions,
    tuple.loading
  ] as const;
}
